import { useStore } from 'effector-react'
import {
  $decryptionPassword,
  $ownerWallets,
  $passwordIncorrect,
  $showPasswordSection,
  getOwnerWalletList,
  ownerWalletListMounted,
  putEncodingPassword
} from './model'
import * as React from "react";

export const useOwnerWalletList = () => {
  React.useEffect(() => {
    ownerWalletListMounted()
  }, [])
  const loadingWallets = useStore(getOwnerWalletList.pending)
  const loadingSetPassword = useStore(putEncodingPassword.pending)

  const ownerWallets = useStore($ownerWallets)
  const decryptionPassword = useStore($decryptionPassword)

  const showPasswordSection = useStore($showPasswordSection)
  const passwordIncorrect = useStore($passwordIncorrect)

  return {
    ownerWallets,
    loading: loadingWallets || loadingSetPassword,
    decryptionPassword,
    showPasswordSection,
    passwordIncorrect,
  }
}
